import { render } from "./Ajustes.vue?vue&type=template&id=443930c5&scoped=true"
import script from "./Ajustes.vue?vue&type=script&lang=js"
export * from "./Ajustes.vue?vue&type=script&lang=js"

import "./Ajustes.vue?vue&type=style&index=0&id=443930c5&scoped=true&lang=css"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443930c5"]])

export default __exports__